import React from "react";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import { ExpandedDescriptionTextSection } from "~/ProductDetails/ProductDetailPageResult";
import ExpandedDescriptionClip from "../ExpandedDescriptionClip";
interface SectionProps {
  section: ExpandedDescriptionTextSection;
  videoClassNames?: string;
}
const Section = ({
  section,
  videoClassNames
}: SectionProps) => {
  return <>
      {!!section.image.length && <div className={`template-image${section.imageHasPadding ? " exp-crop-padding" : ""}`} aria-hidden="true">
          <NoScriptLazyImage alt="" src={section.image} className="expanded-img expanded-large lazyLoad b-loaded" />
        </div>}
      {!!section.video?.sources && !!section.video?.videoPath && <ExpandedDescriptionClip loops={section.isVideoRepeating ? 5 : 1} type={section.type} video={section.video} videoClassNames={videoClassNames} />}
      <div className="template-text">
        {section.headline && <h3 className="item-header" dangerouslySetInnerHTML={{
        __html: section.headline
      }} />}
        {section.body && <p dangerouslySetInnerHTML={{
        __html: section.body
      }} />}
      </div>
    </>;
};
export default Section;